import { z } from 'zod';

const WarehouseDTO = z.object({
    status: z.enum(['IN_STOCK', 'OUT_OF_STOCK']),
    deliveryMessage: z.string().optional(),
});

const StoreDTO = z.object({
    status: z.enum(['IN_STOCK', 'OUT_OF_STOCK']),
    deliveryMessage: z.string().optional(),
});

export const ProductStockDTO = z.object({
    warehouse: WarehouseDTO,
    store: StoreDTO,
});

export type ProductStockDTO = z.infer<typeof ProductStockDTO>;
